import { FinancialTabContent } from "@/components/patients/FinancialTabContent";
import { useFinancialSummary } from "@/hooks/useFinancialSummary";
import { useTranslation } from "react-i18next";

interface OwnerFinancialTabProps {
  ownerId: string;
  petIds: string[];
}

export function OwnerFinancialTab({ ownerId, petIds }: OwnerFinancialTabProps) {
  const { t } = useTranslation("patients");
  const { data, isLoading, error } = useFinancialSummary({ scope: "owner", ownerId, petIds });

  return (
    <FinancialTabContent
      summary={data?.summary}
      openAppointments={data?.openAppointments}
      paymentHistory={data?.paymentHistory}
      sales={data?.sales}
      openReceivables={data?.openReceivables}
      isLoading={isLoading}
      error={error}
      emptyMessage={t("financialTab.empty.owner")}
      showPetColumn
    />
  );
}
